// ADENDA z31 (Diego, 26-oct): «desde que se cargan, para que el que haga la cotización vea bien qué está cargando y los
// consumos del cliente ya sea mensual o bimestral». Cartel grande con la facturación del recibo y las fechas de su último
// periodo, en Recibos y en Revisión.
import type { LecturaRecibo } from '@cotizador/compartido';
import { periodoCorto } from '../../logica/lectura.ts';

/** `enRecibos`: en Recibos no hay campo «Facturación» (está en Revisión): el cartel manda allá (z35-4). */
export function CartelFacturacion({ facturacion, leida, lectura, enRecibos = false }: { facturacion: 'mensual' | 'bimestral' | null; leida: boolean; lectura: LecturaRecibo | null; enRecibos?: boolean }) {
  const pf = lectura?.periodo_facturado ?? null;
  const fechado = [...(lectura?.historial ?? [])].reverse().find((h) => h.inicio && h.fin) ?? null;
  const periodo = pf?.inicio && pf.fin ? periodoCorto(pf.inicio, pf.fin) : fechado ? periodoCorto(fechado.inicio!, fechado.fin!) : null;
  if (!facturacion)
    return (
      <div className="aviso-ancho aviso-ancho--ambar cartel-facturacion" role="status" aria-label="Facturación del recibo">
        <strong className="cartel-facturacion__tipo">¿MENSUAL O BIMESTRAL?</strong>
        <span>El recibo no dice cada cuánto se factura: elígelo en {enRecibos ? 'Revisión, en «Facturación»,' : '«Facturación»'} para que cada consumo cuente como mes o como bimestre.</span>
      </div>
    );
  const bimestral = facturacion === 'bimestral';
  return (
    <div className="aviso-ancho aviso-ancho--info cartel-facturacion" role="status" aria-label="Facturación del recibo">
      <strong className="cartel-facturacion__tipo">{bimestral ? 'BIMESTRAL' : 'MENSUAL'}</strong>
      <span>
        {bimestral ? 'El recibo llega cada 2 meses: cada consumo es kWh del bimestre' : 'El recibo llega cada mes: cada consumo es kWh del mes'}
        {periodo ? ` · último periodo: ${periodo}` : ''}
        {leida ? '' : ' · el recibo no lo dice: es la que usó el cálculo'}
      </span>
    </div>
  );
}
